import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=38233720&scoped=true&"
import script from "./js/dashboard.js?vue&type=script&lang=js&"
export * from "./js/dashboard.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38233720",
  null
  
)

export default component.exports